export interface WalkthroughStepStateProgress {
    expected: number;
    actual: number;
}

export interface WalkthroughStepStateJSON {
    done: boolean;
    doneAt?: string;
    id: string;
    progress?: WalkthroughStepStateProgress;
    steps?: WalkthroughStepStateJSON[];
}

export class WalkthroughStepState {
    done: boolean;
    doneAt?: string;
    id: string;
    progress?: WalkthroughStepStateProgress;
    steps?: WalkthroughStepState[];

    constructor(id: string,
                done: boolean,
                doneAt?: string,
                progress?: WalkthroughStepStateProgress,
                steps?: WalkthroughStepState[]) {
        this.done = done;
        this.doneAt = doneAt === null ? undefined : doneAt;
        this.id = id;
        this.progress = progress === null ? undefined : progress;
        this.steps = steps === null ? undefined : steps;
    }

    public static stateFromJSON(json: WalkthroughStepStateJSON): WalkthroughStepState {
        const state = new WalkthroughStepState(json.id,
                                               json.done,
                                               json.doneAt,
                                               json.progress);
        if (json.steps && json.steps.length > 0) {
            state.steps = json.steps.map(stepJSON => {
                return WalkthroughStepState.stateFromJSON(stepJSON);
            });
        }
        return state;
    }
}
